var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2333 18.5312C1.4333 19.0813 1.4333 30.4313 9.2333 30.9813H12.4334",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31663 18.5318C3.96664 3.64844 26.5332 -2.30155 29.1165 13.3318C36.3332 14.2485 39.25 23.8651 33.7833 28.6485C32.1166 30.1651 29.9666 30.9984 27.7166 30.9818H27.5666",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 27.5501C28.3334 28.7835 28.0667 29.9501 27.5667 30.9835C27.4334 31.2835 27.2834 31.5668 27.1168 31.8335C25.6834 34.2501 23.0334 35.8835 20.0001 35.8835C16.9667 35.8835 14.3167 34.2501 12.8834 31.8335C12.7167 31.5668 12.5668 31.2835 12.4335 30.9835C11.9335 29.9501 11.6667 28.7835 11.6667 27.5501C11.6667 22.9501 15.4001 19.2168 20.0001 19.2168C24.6001 19.2168 28.3334 22.9501 28.3334 27.5501Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3999 27.5513L19.0499 29.2013L22.5999 25.918",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudAdd);
export default __webpack_public_path__ + "static/media/cloud-add.a3a9d5a453189aa8c8f880e8dfa010a7.svg";
export { ForwardRef as ReactComponent };